<!-- 财务 -> 流水明细 -->
<template>
    <div class="templete">
        <div class="search_box clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
            <!-- <el-input class="search_input search_inputBox" v-model="params.search.account_name" placeholder="我方账户名称"></el-input> -->
            <el-input class="search_input search_inputBox" v-model="params.search.course_title" placeholder="科目名称"></el-input>
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="addFlow">添加流水</el-button> -->
            <!-- <el-button class="funcPublicBtn">修改</el-button> -->
            <el-button class="funcPublicBtn" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="batchDel">批量删除</el-button>
            <div class="machBack" @click="Back">返回列表</div>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">总收入:{{totalObj.in_amount}}</div>
            <div class="totalNumber">总支出:{{totalObj.out_amount}}</div>
            <div class="totalNumber">账户余额:{{totalObj.account_balance}}</div>
        </div>
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                start_time:"",
                end_time:new Date(),
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        // account_name:"",
                        course_title:"",
                        customer_id:"",
                        account_id:"",
                    },
                    page:1,
                    per_page:50
                },
                account_id:"",
                last_page:1,
                total:0,
                selectRow:[],
                selectMap:{
                    customer:[],
                    account:[],
                    paymentType:[]
                },
                trading_time:"",
                list:[],
                tableCol:[	
                    {colName:"交易日期",colKey:"trading_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"科目名称",colKey:"course_title",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"我方账户名称",colKey:"account_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"收入",colKey:"in_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"支出",colKey:"out_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"账户余额",colKey:"account_balance",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单据编号",colKey:"order_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"经办人",colKey:"operator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"创建日期",colKey:"create_time",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                totalObj:{}
            }
        },
        created(){
            this.getSelectList("account")
            this.getSelectList("customer")
            this.account_id = sessionStorage.getItem("DEMU_ERP_PURCHASE_FLOWDETAIL_ACCOUNT")
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_FLOWDETAIL_ACCOUNT")
            this.getList()
        },
        methods:{
            Back(){
                this.$root.$children[0].$children[0].addTab({
                    name: '账户管理',
                    label: '账户管理',
                    content: 'accountManage'
                });
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        let ids = arr.toString();
                        this.postFunc("/erp/bill.delete",{ids:ids},()=>{
                            this.tip('删除成功','success');
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time="",
                this.end_time=new Date(),
                this.params={search:{start_time:"",end_time:"",course_title:"",customer_id:""},page:1,per_page:50}
                this.params.search.account_id = this.account_id;
                this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.account_id = this.account_id;
                this.params.search.start_time=this.formatTimeZero(this.start_time)
                this.params.search.end_time=this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.postFunc("/erp/finance.bill.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.totalObj=res.data.data.statistics;
                    this.totalObj.in_amount=this.keepPrice(res.data.data.statistics.in_amount);
                    this.totalObj.out_amount=this.keepPrice(res.data.data.statistics.out_amount);
                    this.totalObj.account_balance=this.keepPrice(res.data.data.statistics.account_balance);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        if(item.trading_time!=0){
                            this.list[index].trading_time = this.formatTime(item.trading_time+"000")
                        }else{
                            this.list[index].trading_time = "";
                        }
                        if(item.create_time!=0){
                            this.list[index].create_time = this.formatTimeSecond(item.create_time+"000")
                        }else{
                            this.list[index].create_time = "";
                        }
                        if(Number(item.in_amount)==0){
                            this.list[index].in_amount = "";
                        }else{
                            this.list[index].baseColor = "#FF0000";
                        }
                        if(Number(item.out_amount)==0){
                            this.list[index].out_amount = "";
                        }else{
                            this.list[index].baseColor = "green";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(){
                
            },
            getRow(row){
                this.selectRow=row;
            },
            excelExport(){
                this.$exportExecl("/erp/finance.bill.export","流水明细",this.params)
            },
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                }
            },
        }
    }
</script>
<style scoped lang="scss">
</style>
